module.exports = __webpack_public_path__ + "images/emoji/clock1230.04aeaaf1629f231af1ba.png";